var map = {
	"./decidim/avatar-multiuser.png": 4407,
	"./decidim/brands/facebook.svg": 74599,
	"./decidim/brands/google.svg": 99790,
	"./decidim/brands/twitter-x.svg": 42951,
	"./decidim/cc-badge.png": 2237,
	"./decidim/decidim-logo.svg": 18213,
	"./decidim/default-avatar.svg": 41541,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 3931,
	"./decidim/icons.svg": 67092,
	"./decidim/pattern.png": 24295,
	"./decidim/placeholder-card-g.svg": 5660,
	"./decidim/placeholder-card-l.svg": 90919,
	"./decidim/placeholder.jpg": 25694,
	"./decidim/remixicon.symbol.svg": 14772,
	"./decidim/vendor/social-share-button/douban.svg": 50695,
	"./decidim/vendor/social-share-button/email.svg": 32432,
	"./decidim/vendor/social-share-button/facebook.svg": 70412,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 64072,
	"./decidim/vendor/social-share-button/hacker_news.svg": 76708,
	"./decidim/vendor/social-share-button/linkedin.svg": 67350,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 21839,
	"./decidim/vendor/social-share-button/pinterest.svg": 47998,
	"./decidim/vendor/social-share-button/reddit.svg": 96116,
	"./decidim/vendor/social-share-button/telegram.svg": 67833,
	"./decidim/vendor/social-share-button/tumblr.svg": 91734,
	"./decidim/vendor/social-share-button/twitter.svg": 35501,
	"./decidim/vendor/social-share-button/vkontakte.svg": 19631,
	"./decidim/vendor/social-share-button/wechat.svg": 40794,
	"./decidim/vendor/social-share-button/whatsapp.svg": 3322,
	"./decidim/vendor/social-share-button/x.svg": 80144,
	"./decidim/vendor/social-share-button/xing.svg": 32312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76154;